export default {
    HEADER: 'Promotion',
    PLACEHOLDER_NAME: 'Eneter promotion name',
    LABEL_NAME: 'Promotion name',
    LABEL_PAGE: 'Page',
    LABEL_IMPORTANCE: 'Importance',
    LABEL_TYPE: 'Type',
    LABEL_PRICE: 'Price',
    PLACEHOLDER_PRICE: 'Enter price',
    PLACEHOLDER_DISCOUNTED_PRICE: 'Enter discounted price',
    LABEL_LIFECYCLE_STATUS: 'Status',
    LABEL_DISCOUNTED_PRICE: 'Discounted price',
    LABEL_START_DATE: 'Promotion start date',
    LABEL_END_DATE: 'Promotion end date',
    SAVE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
    DISCOUNTED_PRICE_INFO:
        'The discounted price field is disabled until you enter a price. Please leave the field empty if there is no discount. For the discounted price amount, enter a value greater than 0 and less than the price value!',
};
